import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useGlobalFonts } from "../hooks/useGlobalFonts";
import footerEllipse from "../assets/footer/footer-ellipse.svg";
import useScrollToTop from "../hooks/useScrollToTop";

const HomepageLayout = () => {
  useGlobalFonts();
  useScrollToTop();
  const location = useLocation();

  return (
    <div className="relative flex flex-col min-h-screen z-10">
      {location.pathname === "/solutions" && (
        <img
          src={footerEllipse}
          alt=""
          aria-hidden
          className="pointer-events-none absolute left-1/2 -z-[10] -translate-x-1/2 top-0 rotate-180 md:w-full w-screen max-w-none"
        />
      )}
      {location.pathname.startsWith("/solutions/") && (
        <img
          src={"/solutions-hero.jpg"}
          alt=""
          aria-hidden
          className="pointer-events-none absolute top-0 right-0 -z-[10]
          h-[580px] min-[420px]:h-[550px] min-[480px]:h-[480px] md:h-[500px] w-[300px] md:w-[600px] lg:w-[800px] object-cover
          max-w-none
          [mask-image:linear-gradient(to_left,black_2%,transparent)]
          [mask-repeat:no-repeat]
          [mask-size:100%_100%]"
        />
      )}
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  );
};

export default HomepageLayout;
